export class StorageTab {

  containerSelector = undefined
  $element = undefined

  options = {
    id: "tab",
    name: "Tab",
    height: 400,
    width: 300,
    active: false,
    position: {
      x: 10,
      y: 100
    }
  }

  events = []
  lastEventSet = undefined

  constructor(container, options) {
    this.containerSelector = container;
    Object.assign(this.options, options);
  }

  drawTab() {
    let that = this;
    this.options.active = false;
    document.body.querySelector(this.containerSelector).innerHTML += require("./templates/tab.hbs")({
      width: that.options.width,
      height: that.options.height,
      position: that.options.position,
      id: that.options.id,
      name: that.options.name
    });
    this.$element = document.body.querySelector(this.containerSelector).querySelector("div[tab-id='" + that.options.id + "']");

    $(this.$element).find(".gc-tab-header-close").click(function () {
      that.closeTab();
    })
  }

  drawEvents() {
    let that = this;
    let $tabeventcontainer = this.$element.querySelector(".gc-tab-events");
    $tabeventcontainer.innerHTML = "";
    this.events.forEach(e => {
      let durationText = sprintf("%02d:%02d", e.duration / 60, e.duration % 60)

      let hasInspectionWarnings = false;
      let hasPartsToPurchase = false;
      let hasPartsToReceive = false;
      
      if (e.has_inspection_warnings) {
        hasInspectionWarnings = true;
      }

      for (const d of e.details) {
        if (d.invoice_detail_parts_status == "1") {
          hasPartsToPurchase = true;
        }
        if (d.invoice_detail_parts_status == "2") {
          hasPartsToReceive = true;
        }
      }

      let titletext = e.details && e.details.length > 0 ? e.description + "\n\nServices:" : e.description + "\n\nAucun service";
      e.details.forEach(svc => {
        titletext += "\n• " + svc.item_name;
      });

      let durationColor = "rgb(71, 255, 111)";
      if(hasPartsToPurchase){
        durationColor = "rgb(255, 92, 92)";
      } else if(hasPartsToReceive){
        durationColor = "rgb(255, 235, 92)";
      }

      let durationBackgroundColor = "#444";
      if(hasInspectionWarnings){
        durationBackgroundColor = "#a70000";
      }

      $tabeventcontainer.innerHTML += require("./templates/tabevent.hbs")({
        id: e.id,
        color: e.color,
        forecolor: e.forecolor,
        title: titletext,
        customer: e.customer_name,
        event: e,
        description: String(e.description || "").replace(/\n/g, "<br />"),
        details: e.details,
        durationText: durationText,
        hasInspectionWarnings: hasInspectionWarnings,
        hasPartsToPurchase: hasPartsToPurchase,
        hasPartsToReceive: hasPartsToReceive,
        durationColor: durationColor,
        durationBackgroundColor: durationBackgroundColor,
        isLinked: e.is_linked,
        linkedno: e.linked_no
      });
    })
  }

  getEvents() {
    return this.events;
  }

  toggleTab() {
    if (!this.options.active) {
      this.openTab();
    } else {
      this.closeTab();
    }
  }

  closeTab() {
    this.options.active = false;
    let $tab = document.body.querySelector(this.containerSelector).querySelector("div[tab-id='" + this.options.id + "']");
    $($tab).addClass("hidden")
  }

  openTab() {
    this.options.active = true;
    let $tab = document.body.querySelector(this.containerSelector).querySelector("div[tab-id='" + this.options.id + "']");
    $($tab).removeClass("hidden");
  }

  addEvent(event) {
    this.lastEventSet = JSON.parse(JSON.stringify(this.events));
    this.events.push(event);
  }

  removeEvent(id) {
    this.lastEventSet = JSON.parse(JSON.stringify(this.events));
    this.events = this.events.filter(e => e.id != id);
  }

  clearEvents() {
    this.lastEventSet = JSON.parse(JSON.stringify(this.events));
    this.events = [];
  }

  resetLastSet() {
    this.lastEventSet = undefined;
  }

  restoreLastSet() {
    if (this.lastEventSet !== undefined) {
      this.events = this.lastEventSet;
    }
  }

}